import { render } from "./Saturation.vue?vue&type=template&id=8982eb4a&scoped=true&ts=true"
import script from "./Saturation.vue?vue&type=script&lang=ts"
export * from "./Saturation.vue?vue&type=script&lang=ts"

import "./Saturation.vue?vue&type=style&index=0&id=8982eb4a&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8982eb4a"]])

export default __exports__